const downloads = [
  { label: "PDF", description: "适合打印或在手机上翻阅。", href: "https://github.com/eternity4719/HowToLiveBetter/releases/download/epub-latest/HowToLiveBetter.pdf" },
  { label: "EPUB", description: "适合电子书阅读器。", href: "https://github.com/eternity4719/HowToLiveBetter/releases/download/epub-latest/HowToLiveBetter.epub" },
  { label: "离线单文件 HTML", description: "下载后可在浏览器中打开。", href: "https://github.com/eternity4719/HowToLiveBetter/releases/download/epub-latest/HowToLiveBetter.html" }
];

export function DownloadPage() {
  return <div className="page download-page">
    <section className="page-heading"><span className="eyebrow">原项目提供</span><h1>下载原书</h1><p>选择适合你的阅读格式。点击后会前往原项目的 GitHub Release 下载。</p></section>
    <div className="download-list">{downloads.map((entry) => <a key={entry.label} href={entry.href} target="_blank" rel="noopener noreferrer"><span><strong>{entry.label}</strong><small>{entry.description}</small></span><span aria-hidden="true">↗</span></a>)}</div>
    <p className="download-version-note">这些链接由原项目维护，指向其最新生成的文件，内容版本可能与本站固定版本不同。要阅读本站对应的完整原文，请使用<a href="#/library">完整原书</a>。</p>
  </div>;
}
